import { format, parseISO } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';

export function FormattedDate({ isoDate, timeZone = 'America/Los_Angeles', formatPattern = 'dd/MM/yyyy HH:mm:ss' }) {
    if (!isoDate) return '-';

    try {
        return formatInTimeZone(
            parseISO(isoDate),
            timeZone,
            formatPattern
        );
    } catch (error) {
        console.error('Error formatting date:', error);
        return isoDate;
    }
}
